var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDisasterRelief = function SvgDisasterRelief(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34850_2683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1596 8.48302C11.0999 8.4474 11.0318 8.42859 10.9623 8.42859C10.8928 8.42859 10.8247 8.4474 10.765 8.48302C10.7158 8.522 10.6826 8.57766 10.6717 8.63946C10.6608 8.70126 10.6729 8.76493 10.7058 8.81839C11.919 10.9193 12.1755 13.7797 10.5184 15.3579C9.88088 14.8221 9.37472 14.1473 9.03889 13.3852C8.42611 13.7255 7.91825 14.2272 7.57048 14.8359C7.22271 15.4445 7.04829 16.1367 7.06619 16.8374C7.09121 17.4552 7.23952 18.0617 7.50242 18.6212C7.76532 19.1807 8.13749 19.6822 8.59702 20.0957C9.05656 20.5093 9.59418 20.8267 10.1782 21.0294C10.7623 21.2322 11.381 21.316 11.998 21.276C15.174 21.276 16.8212 19.3033 16.9298 16.8374C17.0579 13.8784 14.957 10.2387 11.1596 8.48302Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.71436 8.42858C2.71436 5.27267 5.27273 2.71429 8.42864 2.71429",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2858 8.42858C21.2858 5.27267 18.7274 2.71429 15.5715 2.71429",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.28589 8.42859C6.28589 7.24512 7.24527 6.28574 8.42875 6.28574",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7144 8.42859C17.7144 7.24512 16.755 6.28574 15.5715 6.28574",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34850_2683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDisasterRelief);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "disaster-relief.182933a519dcb8bbae0c0709254d8935.svg";